import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';

@Component({
  selector: 'app-apisettings',
  templateUrl: './apisettings.component.html',
  styleUrls: ['./apisettings.component.css']
})
export class ApisettingsComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) { }

  APISettingsCollection:any[];

  ngOnInit(): void {
    this.GetAPiSettings();
  }

  GetAPiSettings(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetAPiSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.APISettingsCollection = response["APISettingsCollection"];
      }
   
      this.parent.loading = false;
    });
  }

  UpdateAPISettings(a:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      APISettings:a
    };

    this.parent.loading = true;

    this.service.UpdateAPISettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.APISettingsCollection.filter(x => x.ID == a.ID).forEach(x => x = response["APISettings"]);
      }
   
      this.parent.loading = false;
    });
  }

}
